import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AwardComparisonPage } from "components/pages/AwardComparisonPage";
import { CumulativeLoanDebtPage } from "../pages/CumulativeLoanDebtPage";
import FinancesPage from "components/pages/FinancesPage";
import { FinancialAidScholarshipsPage } from "../pages/FinancialAidScholarshipsPage";
import { LoanSummaryByAidYearPage } from "../pages/LoanSummaryByAidYearPage";
import { AwardsByTermPage } from "components/pages/AwardsByTermPage";
import { LoanResourcesPage } from "components/pages/LoanResourcesPage";

export default function FinancesRoutes() {
  return (
    <Routes>
      <Route path="" element={<FinancesPage />} />
      <Route path="finaid" element={<Navigate to="/finances" />} />
      <Route
        path="finaid/:finaidYearId"
        element={<FinancialAidScholarshipsPage />}
      />
      <Route
        path="finaid/awards/:finaidYearId"
        element={<AwardsByTermPage />}
      />
      <Route
        path="finaid/compare/:finaidYearId"
        element={<AwardComparisonPage />}
      />
      <Route path="cumulative_loan_debt" element={<CumulativeLoanDebtPage />} />
      <Route
        path="loan_summary_aid_year"
        element={<LoanSummaryByAidYearPage />}
      />
      <Route path="loan_resources" element={<LoanResourcesPage />} />
    </Routes>
  );
}
